<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Delivery Status Report</strong>        
            <div class="card-header-actions">
              <a  @click="refresh" title="Refresh">  <span class="icon is-medium" >
                <span class="fa fa-refresh" id="refreshId" > </span>
                </span>
              </a>
            </div> 
          </div>
          
            
            <b-form data-vv-scope="form-1">
              <b-row class="mb-4">
                 <b-col md="4">
                   <b-form-group label="Select Rider"  :label-cols="4" >

                    <ejs-multiselect id='multiselect' placeholder="Select Rider" v-model="value2" :dataSource='options'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>

                 
                    <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
                  </b-form-group>
                </b-col>  
                 <b-col md="4">
                   <b-form-group label="Select Date"  :label-cols="4" >

                   <v-date-picker  mode='single'  :available-dates='{ start: null, end: new Date() }' v-model='selectedDate'>
                      </v-date-picker>

                    <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
                  </b-form-group>
                </b-col>  
                
                  <b-col sm="3">
                    <b-form-group>
                     <b-button  size="md" variant="primary" v-on:click="displaydata()"> Submit</b-button> &nbsp;
                      
                    </b-form-group>
                  </b-col>
              
              </b-row>          
            </b-form> 
            
            <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows}}</span></b> </p>
              </b-col> 
      
 
<div>
  <b-row>
    <b-col>
      <button type="submit" size="md" id="hideshowbutton" class="btn btn-primary btn-md" variant="primary" @click="visible = !visible">{{ visible ? 'Show Details' : ' Hide Details'}} </button>
    </b-col>
    <b-col>
      <b-button v-if="totalRows>0" type="submit" variant="primary" size="md" @click="downloadCSV()" style="float: right">Download </b-button>
    </b-col>
  </b-row>
</div>
  <!-- <div id="overlay" >
    <div class="loader"></div>
  </div> -->
  
  <div style="overflow-x:auto;">
    <table stickyheader="" role="table" aria-busy="false" aria-colcount="15" class="table b-table table-bordered " id="__BVID__132" aria-describedby="__BVID__132__caption_" >
      <!----><!---->
      <thead role="rowgroup" class="tableheades">
          <!---->
          <tr role="row">
            <th tabindex="0" role="columnheader" scope="col" aria-colindex="1" class="">Name </th>
            <th tabindex="0" role="columnheader" scope="col" aria-colindex="2" class="">Forward <div style="float: right;" tabindex="0" role="columnheader" scope="col" aria-colindex="2"><div class="arrow-up" @click="displaydata('forwardpickup',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('forwardpickup',' desc')"></div></div>Pickup </th>

            <th tabindex="0" role="columnheader" scope="col" aria-colindex="3" >Reverse <div style="float: right;"><div class="arrow-up" @click="displaydata('reversepickup',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('reversepickup',' desc')"></div></div>Pickup </th>

            <th tabindex="0" role="columnheader" scope="col" aria-colindex="4" >Pallet Shipment Count<div style="float: right;"><div class="arrow-up" @click="displaydata('palletshipmentcount',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('palletshipmentcount',' desc')"></div></div></th>

            <th tabindex="0" role="columnheader" scope="col" aria-colindex="4" >OFD<div style="float: right;"><div class="arrow-up" @click="displaydata('deliverypending',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('deliverypending',' desc')"></div></div></th>

            <th tabindex="0" role="columnheader" scope="col" aria-colindex="5" >ROFD<div style="float: right;"><div class="arrow-up" @click="displaydata('deliverypendingreturn',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('deliverypendingreturn',' desc')"></div></div></th>

            <th tabindex="0" role="columnheader" scope="col" aria-colindex="6" style="width:170px;">INTRANSIT<div style="float: right;"><div class="arrow-up" @click="displaydata('deliverypendingintransit',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('deliverypendingintransit',' desc')"></div></div></th>

            <th tabindex="0" role="columnheader" scope="col" aria-colindex="7" >Delivered<div style="float: right;"><div class="arrow-up" @click="displaydata('totaldelivered',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('totaldelivered',' desc')"></div></div></th>

            <th tabindex="0" role="columnheader" scope="col" aria-colindex="8" >RVP<div style="float: right;"><div class="arrow-up" @click="displaydata('handoverpending',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('handoverpending',' desc')"></div></div>-HOP</th>

            <th tabindex="0" role="columnheader" scope="col" >RVP <div style="float: right;"><div class="arrow-up" @click="displaydata('reversepickcancel',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('reversepickcancel',' desc')"></div></div>NPR</th>

            <th tabindex="0" role="columnheader" scope="col" aria-colindex="9" >NDR <div style="float: right;"><div class="arrow-up" @click="displaydata('ndr',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('ndr',' desc')"></div></div></th>

            <th tabindex="0" role="columnheader" scope="col" aria-colindex="10" > RTO <div style="float: right;"><div class="arrow-up" @click="displaydata('totalrto',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('totalrto',' desc')"></div></div></th>

            <th tabindex="0" role="columnheader" scope="col" aria-colindex="11" >COD <div style="float: right;"><div class="arrow-up" @click="displaydata('codcollectable',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('codcollectable',' desc')"></div></div>Collected </th>

              <th tabindex="0" role="columnheader" scope="col" aria-colindex="13" >First <div style="float: right;"><div class="arrow-up" @click="displaydata('StartTime',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('StartTime',' desc')"></div></div>Delivery </th>

              <th tabindex="0" role="columnheader" scope="col" aria-colindex="14" >Last <div style="float: right;"><div class="arrow-up" @click="displaydata('EndTime',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('EndTime',' desc')"></div></div>Delivery </th>

            <th tabindex="0" role="columnheader" scope="col" >Total <div style="float: right;"><div class="arrow-up" @click="displaydata('totalofd',' asc')"></div>&nbsp;<div class="arrow-down" @click="displaydata('totalofd',' desc')"></div></div>OFD </th>
              
            <!-- <th tabindex="0" role="columnheader" scope="col" aria-colindex="11" class="">Show Details</th> -->
          </tr>
      </thead>
      <!---->
      <div style=" position: absolute; left: 500px;" v-if="this.totalRows==0">
        <b-spinner variant="danger" style="width: 2rem; height: 2rem;"></b-spinner>
        <h5 style=" font-weight: bold;  position: absolute; left: 35px;
        top: 4px; color: #ff0000a3;">Loading...</h5>
      </div>

      <tbody role="rowgroup" class="" >
          <tr role="row" >
            <td class="totalback widthclass"><b>Total</b></td>
            <td class="totalback widthclass"><b>{{forwardpickuptotal}}</b></td>
            <td class="totalback widthclass"><b>{{reversepickuptotal}}</b></td>
            <td class="totalback widthclass"><b>{{palletshipmentcount}}</b></td>
            <td class="totalback widthclass"><b>{{deliverypendingtotal}}</b></td>
            <td class="totalback widthclass"><b>{{deliverypendingreturntotal}}</b></td>
            <td class="totalback widthclass"><b>{{deliverypendingintransittotal}}</b></td>
            <td class="totalback widthclass"><b>{{totaldeliveredtotal}}</b></td>
            <td class="totalback widthclass"><b>{{handoverpendingtotal}}</b></td>
            <td class="totalback widthclass"><b>{{rvpnprtotal}}</b></td>
            <td class="totalback widthclass"><b>{{ndrtotal}}</b></td>
            <td class="totalback widthclass"><b>{{rtototal}}</b></td>
            <td class="totalback widthclass"><b>{{codcollectabletotal}}</b></td>
            <td class="totalback widthclass"><b>{{firstdelivery}}</b></td>
            <td class="totalback widthclass"><b>{{lastdelivery}}</b></td>
            <td class="totalback widthclass"><b>{{ofdtotal}}</b></td>
            
            <!-- <td class="totalback"><b></b></td> -->
          </tr>
        <!--  totalunique cx code row -->
            <tr role="row" v-if="visible">
              <td class="totalunique"><b>Total Unique CX</b></td>
              <td class="totalunique">{{forwardpickuptotalunique}}</td>
              <td class="totalunique">{{reversepickuptotalunique}}</td>
              <td class="totalunique">{{palletshipmentcount}}</td>
              <td class="totalunique">{{deliverypendingtotalunique}}</td>
              <td class="totalunique">{{deliverypendingreturntotalunique}}</td>
              <td class="totalunique">{{deliverypendingintransittotalunique}}</td>
              <td class="totalunique">{{totaldeliveredtotalunique}}</td>
              <td class="totalunique">{{handoverpendingtotalunique}}</td>
              <td class="totalunique">{{ofdtotalunique}}</td>
              <td class="totalunique">{{ndrtotalunique}}</td>
              <td class="totalunique">{{rtototalunique}}</td>
              <td class="totalunique">{{codcollectabletotalunique}}</td>
              <td class="totalunique">{{firstdeliveryunique}}</td>
              <td class="totalunique">{{lastdeliveryunique}}</td>
              <td class="totalunique">{{rvpnprtotalunique}}</td>
            
              
            </tr>
        
          <tr role="row" class="unvisiblemob" v-for="items in items">
            <td role="cell" aria-colindex="1" data-label="Name" class="">
                <span>{{items.daname}}</span>
                
            </td>
            <td role="cell" aria-colindex="2" data-label="Forward Pickup" class="">
                <span>{{items.forwardpickup}}</span>
                <span v-if="visible">{{items.uniqueforwardpickup}}</span>
            </td>

            <td role="cell" aria-colindex="3" data-label="Reverse Pickup" class="">
                <span>{{items.reversepickup}}</span>
                <span v-if="visible">{{items.uniquereversepickup}}</span>
            </td>

             <td role="cell" aria-colindex="3" data-label="Pallet Count" class="">
                <span>{{items.palletshipmentcount}}</span>
                <span v-if="visible"></span>
            </td>

            <td role="cell" aria-colindex="4" data-label="Delivery Pending" class="">
                <span>{{items.deliverypending}}</span>
                <span v-if="visible">{{items.uniquedeliverypending}}</span>
            </td>
              <td role="cell" aria-colindex="5" data-label="Delivery Pending" class="">
                <span>{{items.deliverypendingreturn}}</span>
                <span v-if="visible">{{items.uniquedeliverypendingreturn}}</span>
            </td>
            <td role="cell" aria-colindex="6" data-label="Delivery Pending" class="">
                <span>{{items.deliverypendingintransit}}</span>
                <span v-if="visible">{{items.uniquedeliverypendingintransit}}</span>
            </td>
            <td role="cell" aria-colindex="7" data-label="Delivered" class="">
                <span>{{items.totaldelivered}}</span>
                <span v-if="visible">{{items.uniquetotaldelivered}}</span>
            </td>
            <td role="cell" aria-colindex="8" data-label="RVP-HOP" class="">
                <span>{{items.handoverpending}}</span>
                <span v-if="visible">{{items.uniquehandoverpending}}</span>
            </td>
              <td role="cell" aria-colindex="12" data-label="Total OFd" class="">
                <span>{{items.reversepickcancel}}</span>
                <span v-if="visible">{{items.uniquereversepickcancel}}</span>
                
            </td>
            <td role="cell" aria-colindex="9" data-label="NDR" class="">
                <span>{{items.ndr}}</span>
                <span v-if="visible">{{items.uniquendr}}</span>
            </td>
            <td role="cell" aria-colindex="10" data-label=" RTO" class="">
                <span>{{items.totalrto}}</span>
                <span v-if="visible">{{items.uniquetotalrto}}</span>
            </td>
            <td role="cell" aria-colindex="11" data-label="COD collected" class="">
                <span>{{items.codcollectable}}</span>
                <span v-if="visible"></span>
              
            </td>
            <td role="cell" aria-colindex="13" data-label="First Delivery" class="">
                <span>{{items.StartTime}}</span>
                <span v-if="visible"></span>
              
            </td>
              <td role="cell" aria-colindex="14" data-label="Last Delivery" class="">
                <span>{{items.EndTime}}</span>
                <span v-if="visible"></span>
              
            </td>
            <td role="cell" aria-colindex="15" data-label="Total OFd" class="">
                <span>{{items.totalofd}}</span>
                <span v-if="visible"></span>
                
            </td>
          </tr>

          <tr role="row" class="visiblemob" v-for="items in items">
            <td role="cell" aria-colindex="1" data-label="Name" class="">
                <span>{{items.daname}}</span>
                
            </td>
            <td role="cell" aria-colindex="2" data-label="Forward Pickup" class="">
                <span>{{items.forwardpickup}}</span>
                <span>{{items.uniqueforwardpickup}}</span>
            </td>
            <td role="cell" aria-colindex="3" data-label="Reverse Pickup" class="">
                <span>{{items.reversepickup}}</span>
                <span>{{items.uniquereversepickup}}</span>
            </td>

            <td role="cell" aria-colindex="3" data-label="Pallet Count" class="">
                <span>{{items.palletshipmentcount}}</span>
                <span v-if="visible"></span>
            </td>

            <td role="cell" aria-colindex="4" data-label="Delivery Pending" class="">
                <span>{{items.deliverypending}}</span>
                <span>{{items.uniquedeliverypending}}</span>
            </td>
              <td role="cell" aria-colindex="5" data-label="Delivery Pending" class="">
                <span>{{items.deliverypendingreturn}}</span>
                <span>{{items.uniquedeliverypendingreturn}}</span>
            </td>
            <td role="cell" aria-colindex="6" data-label="Delivery Pending" class="">
                <span>{{items.deliverypendingintransit}}</span>
                <span>{{items.uniquedeliverypendingintransit}}</span>
            </td>
            <td role="cell" aria-colindex="7" data-label="Delivered" class="">
                <span>{{items.totaldelivered}}</span>
                <span>{{items.uniquetotaldelivered}}</span>
            </td>
            <td role="cell" aria-colindex="8" data-label="RVP-HOP" class="">
                <span>{{items.handoverpending}}</span>
                <span>{{items.uniquehandoverpending}}</span>
            </td>
              <td role="cell" aria-colindex="12" data-label="Total OFd" class="">
                <span>{{items.reversepickcancel}}</span>
                <span>{{items.uniquereversepickcancel}}</span>
                
            </td>
            <td role="cell" aria-colindex="9" data-label="NDR" class="">
                <span>{{items.ndr}}</span>
                <span>{{items.uniquendr}}</span>
            </td>
            <td role="cell" aria-colindex="10" data-label=" RTO" class="">
                <span>{{items.totalrto}}</span>
                <span>{{items.uniquetotalrto}}</span>
            </td>
            <td role="cell" aria-colindex="11" data-label="COD collected" class="">
                <span>{{items.codcollectable}}</span>
                <span></span>
              
            </td>
            <td role="cell" aria-colindex="13" data-label="First Delivery" class="">
                <span>{{items.StartTime}}</span>
                <span></span>
              
            </td>
              <td role="cell" aria-colindex="14" data-label="Last Delivery" class="">
                <span>{{items.EndTime}}</span>
                <span></span>
              
            </td>
            <td role="cell" aria-colindex="15" data-label="Total OFd" class="">
                <span>{{items.totalofd}}</span>
                <span></span>
                
            </td>
          </tr>
      </tbody>
    </table>
    </div>
  </b-card>
        
      </b-col>
    </b-row>       
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
export default {

  
  data: function() {
    return {
      name: 'deliveryStatusReport',
      data: [],
      items:[],
      isHidden: true,
       items1:[],
      customer: {},
      visible: false,
      bordered:true,
      selectedDate: new Date(),
      fields: [
          { key: 'daname', label: 'Name', sortable: true, sortDirection: 'desc' },
          { key: 'forwardpickup', label: 'Forward Pickup', sortable: true},
          { key: 'reversepickup', label: 'Reverse Pickup', sortable: true},
          { key: 'deliverypending', label: 'Delivery Pending', sortable: true},
          { key: 'deliverypendingreturn', label: 'Delivery Pending Return', sortable: true},
          { key: 'deliverypendingintransit', label: 'Delivery Pending Intransit', sortable: true},         
          { key: 'totaldelivered', label: 'Delivered', sortable: true },    
          { key: 'handoverpending', label: 'RVP-HOP', sortable: true },
          { key: 'ndr', label: 'NDR', sortable: true },
          { key: 'totalrto', label: ' RTO' , sortable: true},
          // { key: 'failedpickup', label: 'Failed pickup', sortable: true },
          { key: 'codcollectable', label: 'COD collected', sortable: true  },
           { key: 'Today_First_Delivered_Shipment_Time', label: 'First Delivery', sortable: true  },
            { key: 'Today_Last_Delivered_Shipment_Time', label: 'Last Delivery', sortable: true  },
          { key: 'totalofd', label: 'Total OFd' },
          { key: 'show_details' },
       ], 

       
      totalRows: 0,
      currentPage: 1,
         value2:[],
         agentfields: { text: 'name', value: 'id' },
         options: [],
          showSelectAll : true,
           allowCustomValue : true,
     
      pageOptions: [5, 10, 15],
      sortBy: null,
      stickyHeader: true,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      forwardpickuptotal:0,
       reversepickuptotal:0,
        deliverypendingtotal:0,
        deliverypendingreturntotal:0,
        deliverypendingintransittotal:0,
        totaldeliveredtotal:0,
        handoverpendingtotal:0,
        ndrtotal:0,
        rtototal:0,
       // failedpickuptotal:0,
        codcollectabletotal:0,
         ofdtotal:0,
         rvpnprtotal:0,
         firstdelivery:0,
         lastdelivery:0,
         //totoaluniquecx variables
        forwardpickuptotalunique:0,
        reversepickuptotalunique:0,
        deliverypendingtotalunique:0,
        deliverypendingreturntotalunique:0,
        deliverypendingintransittotalunique:0,
        totaldeliveredtotalunique:0,
        handoverpendingtotalunique:0,
        ndrtotalunique:0,
        rtototalunique:0,
        codcollectabletotalunique:0,
        ofdtotalunique:0,
        rvpnprtotalunique:0,
        flag:0,
        firstdeliveryunique:0,
        lastdeliveryunique:0,

        //Added Fields by Sachin
        forwardpickup:'',
        reversepickup:'',
        deliverypending:'',
        deliverypendingreturn:'',
        deliverypendingintransit:'',
        totaldelivered:'',
        handoverpending:'',
        reversepickcancel:'',
        ndr:'',
        totalrto:'',
        codcollectable:'',
        StartTime:'',
        EndTime:'',
        totalofd:'',
        FirstSet: {},
        col_name:'',
        order:'',
        //Added Fileds by Sachin Ends
         //totoaluniquecx variables end
        palletshipmentcount:0,

      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },

  computed: {
    sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
  },


  created: function () {
     this.displaydeliveryagent();
    
  },
  // components: {
  //   collapsible: collapsible
  // },
//   var collapsible = {
//   template: "#collapsible",
  
// }
  methods: {
    
     info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      
//   testDisplay:function(test) {
//     if (document.getElementById("portests").value == "Hide " + test) {
//         document.getElementById("portests").value = "Show " + test;
//         var table= document.getElementById("testing");
//         for (var i = 0, row; row = table.rows[i]; i++) {
//         if(row.className == "test"){row.style.visibility="hidden";}
//         }
//     }
//     else{
//         document.getElementById("portests").value = "Hide " + test;
//         var table= document.getElementById("testing");
//         for (var i = 0, row; row = table.rows[i]; i++) {
//         if(row.className == "test"){row.style.visibility='visible';}
//         }
//     }
// },
    showdata: function (){
      if(isHidden==true){
        isHidden: false;
      }
    }, 
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    // validateForm(scope) {


    // },
   
    refresh: function () {
      document.getElementById('refreshId').className = 'fa-spin fa fa-refresh'
      this.displaydata()
      // this.downloadCSV()
    },
    GetSortOrder : function(prop) {
        return function(a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        }

    },

    //code for download csv
    downloadCSV: function() {
     document.getElementById("overlay").style.display = "block";
     
       var deliveryagentidarr=[];
          deliveryagentidarr=this.value2;
      
      var fromdate = this.formatDate(this.selectedDate);

      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      
           
      const customerGetobj = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          fromdate: `${fromdate}`,
           deliveryagentmasterid:deliveryagentidarr,
            hub_id:`${userInfo.pickuplocationmasterid}`,
            sysusermasterid:`${userInfo.sysusermasterid}`,
            // FirstSetData: this.FirstSet
            // 'FirstSet.+col_name': col_name+''+order
          
        // pickuplocationmasterid:`${userInfo.pickuplocationmasterid}`,
      
      
      }
      if(this.col_name!=undefined){
        customerGetobj['order_by']='FirstSet.'+this.col_name+''+this.order;
      }
      else{
        customerGetobj['order_by']='';
      }
      
      console.log("CSV",customerGetobj)
      // return false;
     this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/statusReportDownloadCsv`, customerGetobj)
        .then((result) => {
          console.log("Result",result);
           document.getElementById("overlay").style.display = "none";
          if(result.body=="success")
         {
         alert("Please Check Ur Mail For Downlod Link")
         
       }
       else
       {
        alert("Can not Download");
       

       }
          // document.getElementById('refreshId').className = 'fa fa-refresh';
        })
        .catch((ex) => {
          console.log('error', ex)
        })
        
    },
    // download csv code end

     displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
         hub_id:`${userInfo.pickuplocationmasterid}`,
      
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
           this.displaydata();
          this.agentmaster = result.body;

           for(var i = 0; i < this.agentmaster.length; i++) {
            var deliveryagent2 = {
        name: this.agentmaster[i].deliveryagentfirstname+" - "+this.agentmaster[i].deliveryagentlastname+" - "+this.agentmaster[i].deliveryagentmasterid,
        id: this.agentmaster[i].deliveryagentmasterid
      }
 this.options.push(deliveryagent2);

        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }
       // console.log('--------gfg----------');
       // console.log(this.options);
       //        console.log('------------------');

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    
    displaydata: function (col_name, order) {
      document.getElementById("overlay").style.display = "block";
     console.log("Col Name",col_name);
     console.log("order Name",order);
     this.col_name=col_name;
     this.order=order;
       var deliveryagentidarr=[];
          deliveryagentidarr=this.value2;
      
      var fromdate = this.formatDate(this.selectedDate);

      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      
           
      const customerGetobj = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          fromdate: `${fromdate}`,
           deliveryagentmasterid:deliveryagentidarr,
            hub_id:`${userInfo.pickuplocationmasterid}`,
            // FirstSetData: this.FirstSet
            // 'FirstSet.+col_name': col_name+''+order
          
        // pickuplocationmasterid:`${userInfo.pickuplocationmasterid}`,
      
      
      }
      if(col_name!=undefined){
        customerGetobj['order_by']='FirstSet.'+col_name+''+order;
      }
      else{
        customerGetobj['order_by']='FirstSet.totalofd desc';
      }
      
      console.log("ddddddddddddddddddDDDDDDDDDDDD",customerGetobj)
      // return false;
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getalldapendingstatusreport_mr`, customerGetobj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            document.getElementById("overlay").style.display = "none";
          this.data = result.body.returnvalue;
          // console.log('hii',this.data);
            this.items = result.body.returnvalue;

           // console.log("JJJJJJJJJJJJJJJJJJJJ",this.items)
          // console.log("PPPPPPPPPPPPPPPPPPPPPPP",this.items);
          // console.log('hello',this.items);
          this.totalRows = result.body.returnvalue.length;

          this.forwardpickuptotal =0;
          this.reversepickuptotal =0;
          this.deliverypendingtotal =0;
          this.deliverypendingreturntotal=0;
          this.deliverypendingintransittotal=0;
          this.totaldeliveredtotal =0;
          this.handoverpendingtotal =0;
          this.ndrtotal=0;
          this.rtototal =0;
          this.codcollectabletotal =0;
          // this.firstdelivery=0;
          // this.lastdelivery=0;
          
          this.ofdtotal =0;
          this.rvpnprtotal=0;
          //this.failedpickuptotal =0;

          //totalunique code
          this.forwardpickuptotalunique=0;
          this.reversepickuptotalunique=0;
          this.deliverypendingtotalunique=0;
          this.deliverypendingreturntotalunique=0;
          this.deliverypendingintransittotalunique=0;
          this.totaldeliveredtotalunique=0;
          this.handoverpendingtotalunique=0;
          this.ndrtotalunique=0;
          this.rtototalunique=0;
          this.codcollectabletotalunique=0;
          this.firstdeliveryunique=0;
          this.lastdeliveryunique=0;
          this.ofdtotalunique=0;
          this.rvpnprtotalunique=0;
          //totalunique code end

          
          for( var i=0;i<= this.items.length;i++)
          {
            
            console.log("palletshipmentcountpalletshipmentcountpalletshipmentcount",this.items[i].totalpalletcount);
            // if(this.items[i].flag != undefined){
            if(this.items[i].flag == 0){
              // console.log("items",this.items[i]);
              this.forwardpickuptotal=parseInt(this.forwardpickuptotal + this.items[i].forwardpickup);
             // console.log("@@@@@@@@@@@this.forwardpickuptotal",this.forwardpickuptotal);

            this.reversepickuptotal=parseInt(this.reversepickuptotal + this.items[i].reversepickup);

           this.deliverypendingtotal=parseInt(this.deliverypendingtotal + this.items[i].deliverypending);
           this.deliverypendingreturntotal=parseInt(this.deliverypendingreturntotal + this.items[i].deliverypendingreturn);
           // console.log("return",this.deliverypendingtotal);
           this.deliverypendingintransittotal=parseInt(this.deliverypendingintransittotal + this.items[i].deliverypendingintransit);
           // console.log("return", this.deliverypendingintransittotal);
            this.totaldeliveredtotal=parseInt(this.totaldeliveredtotal + this.items[i].totaldelivered);

            this.handoverpendingtotal=parseInt(this.handoverpendingtotal + this.items[i].handoverpending);
            this.ndrtotal=parseInt(this.ndrtotal + this.items[i].ndr);

            this.rtototal=parseInt(this.rtototal + this.items[i].totalrto);

            //this.failedpickuptotal=parseInt(this.failedpickuptotal+ this.items[i].failedpickup);

            this.codcollectabletotal= (parseFloat(this.codcollectabletotal) + parseFloat(this.items[i].codcollectable)).toFixed(2);

              this.firstdelivery = this.data.StartTime
              this.palletshipmentcount = this.data.palletshipmentcount

              this.lastdelivery=this.data.EndTime;

            this.ofdtotal=parseInt(this.ofdtotal + this.items[i].totalofd);
             this.rvpnprtotal=parseInt(this.rvpnprtotal + this.items[i].reversepickcancel);

             
            }
            else if(this.items[i].flag == 1){
                this.forwardpickuptotalunique=parseInt(this.forwardpickuptotalunique + this.items[i].uniqueforwardpickup);
            // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$",this.forwardpickuptotalunique);
            this.reversepickuptotalunique=parseInt(this.reversepickuptotalunique + this.items[i].uniquereversepickup);

           this.deliverypendingtotalunique=parseInt(this.deliverypendingtotalunique + this.items[i].uniquedeliverypending);

           this.deliverypendingreturntotalunique=parseInt(this.deliverypendingreturntotalunique + this.items[i].uniquedeliverypendingreturn);

            this.deliverypendingintransittotalunique=parseInt(this.deliverypendingintransittotalunique + this.items[i].uniquedeliverypendingintransit);


            this.totaldeliveredtotalunique=parseInt(this.totaldeliveredtotalunique + this.items[i].uniquetotaldelivered);

            this.handoverpendingtotalunique=parseInt(this.handoverpendingtotalunique + this.items[i].uniquehandoverpending);
            this.ndrtotalunique=parseInt(this.ndrtotalunique + this.items[i].uniquendr);

            this.rtototalunique=parseInt(this.rtototalunique + this.items[i].uniquetotalrto);
            this.rvpnprtotalunique=parseInt(this.rvpnprtotalunique + this.items[i].uniquereversepickcancel);

            //this.failedpickuptotal=parseInt(this.failedpickuptotal+ this.items[i].failedpickup);

            // this.codcollectabletotalunique= (parseFloat(this.codcollectabletotalunique)+ parseFloat(this.items[i].uniquecodcollectable)).toFixed(2);

            // this.ofdtotalunique=parseInt(this.ofdtotalunique+ this.items[i].uniqueofd);

            }


          // }
        }
          // this.totalofdtotal= (parseFloat(this.deliverypendingtotal)+ parseFloat(this.totaldeliveredtotal)+ parseFloat(this.ndrtotal));

          document.getElementById('refreshId').className = 'fa fa-refresh';


          } 
          else 
          {
            document.getElementById("overlay").style.display = "none";
            //alert('No records found')
            this.items=[];
          this.forwardpickuptotal =0;
          this.reversepickuptotal =0;
          this.deliverypendingtotal =0;
          this.deliverypendingreturntotal=0;
          this.deliverypendingintransittotal=0;
          this.totaldeliveredtotal =0;
          this.handoverpendingtotal =0;
          this.ndrtotal=0;
          this.rtototal =0;
          this.codcollectabletotal =0;
          this.firstdelivery=0;
          this.lastdelivery=0;
           this.ofdtotal =0;
            this.totalRows=0;
            this.rvpnprtotalunique=0;
            this.rvpnprtotal=0;
            this.col_name='';
            this.order='';
            this.totalRows=0;

          }

          // //code for unique
           //  this.forwardpickuptotalunique=parseInt(this.forwardpickuptotalunique+ this.items[i].forwardpickupunique);
           //  console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$",this.forwardpickuptotalunique);
           //  this.reversepickuptotalunique=parseInt(this.reversepickuptotalunique+ this.items[i].reversepickupunique);

           // this.deliverypendingtotalunique=parseInt(this.deliverypendingtotalunique+ this.items[i].deliverypendingunique);

           //  this.totaldeliveredtotalunique=parseInt(this.totaldeliveredtotalunique+ this.items[i].totaldeliveredunique);

           //  this.handoverpendingtotalunique=parseInt(this.handoverpendingtotalunique+ this.items[i].handoverpendingunique);
           //  this.ndrtotalunique=parseInt(this.ndrtotalunique+ this.items[i].ndrunique);

           //  this.rtototalunique=parseInt(this.rtototalunique+ this.items[i].totalrtounique);

           //  //this.failedpickuptotal=parseInt(this.failedpickuptotal+ this.items[i].failedpickup);

           //  this.codcollectabletotalunique= (parseFloat(this.codcollectabletotalunique)+ parseFloat(this.items[i].codcollectableunique)).toFixed(2);

           //  this.ofdtotalunique=parseInt(this.ofdtotalunique+ this.items[i].ofdunique);
          //   //code for unique end 

        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  }
};
</script>

<style type="text/css">

@media (max-width: 700px) {

  #hideshowbutton {
    display: none;
  }
  
  .unvisiblemob {
    display: none !important;
  }
 
.b-table-top-row {
  display: block;
  width: 100% !important;
}

.popover-container input  {
  width: 152px;
}

table, thead, tbody, th, td, tr {
  display: block;
  width: 100%;
  max-width: unset !important;
}

.widthclass {
  width: unset !important; 
  max-width : unset !important;
}
.totalback {
  background: #c8ced3 !important;
  border-bottom: 1px solid grey !important;
  width: unset !important; 
  max-width : unset !important;
}
  
tr:nth-child(odd) {
  background: #ccc;
}
.table,
        .table tbody,
        .table tr,
        .table td,
        .table .td div {
          display: block;
          width: 100%;
          max-width: unset !important;
        }
/*
Label the data
You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
*/
td:nth-of-type(1):before { content: "Name : "; font-weight: bolder; }
td:nth-of-type(2):before { content: "Forward Pickup : "; font-weight: bolder;}
td:nth-of-type(3):before { content: "Reverse Pickup : "; font-weight: bolder;}
td:nth-of-type(4):before { content: "OFD : "; font-weight: bolder;}
td:nth-of-type(5):before { content: "ROFD : "; font-weight: bolder;}
td:nth-of-type(6):before { content: "INTRANSIT : "; font-weight: bolder;}
td:nth-of-type(7):before { content: "Delivered : "; font-weight: bolder;}
td:nth-of-type(8):before { content: "RVP - HOP : "; font-weight: bolder;}
td:nth-of-type(9):before { content: "RVP NPR : "; font-weight: bolder;}
td:nth-of-type(10):before { content: "NDR : "; font-weight: bolder;}
td:nth-of-type(11):before { content: "RTO : "; font-weight: bolder;}
td:nth-of-type(12):before { content: "COD Collected : "; font-weight: bolder;}
td:nth-of-type(13):before { content: "First Delivery : "; font-weight: bolder;}
td:nth-of-type(14):before { content: "Last Delivery : "; font-weight: bolder;}
td:nth-of-type(15):before { content: "Total OFD : "; font-weight: bolder;}
}

.visiblemob {
  display: none;
}

 .totalback
 {
  background: #CACDCD !important;
   border-right: 1px solid grey !important;
   

  }
  .totalunique
 {
  background: #DDDFDF!important;
   border-right: 1px solid grey !important;
   

  }
  table {
  width: 100%;
  margin: 20px auto;
  table-layout: auto;
}

/*.fixed {
  table-layout: fixed;
}

table,
td,
th {
  border-collapse: collapse;
}*/


.arrow-up {
  width: 0; 
  height: 0; 
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 7px solid #1E90FF;
}

.arrow-down {
  width: 0; 
  height: 0; 
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 7px solid #1E90FF;
}
</style>